<template>
  <BasicModal id="add-video-modal"
              class="basic-modal add-video-modal"
              v-bind:title="$t('common.modal.add_video.title')"
              v-on:ok="addVideo"
              v-on:cancel="clear">
    <div class="add-video-input-area">
      <input v-bind:placeholder="$t('common.modal.add_video.input_placeholder')" v-model="videoLink" type="url">
    </div>

    <div class="typography--caption typography--color-secondary">
      {{ $t('common.modal.add_video.message') }}
    </div>
  </BasicModal>
</template>

<script>
  import { mapActions } from 'vuex';
  import { isString } from 'lodash';

  export default {
    name: 'add-video-modal',

    data() {
      return {
        videoLink: '',

        youtube: /(^https?:\/\/youtu\.be\/[-_a-zA-Z0-9]+$|^https:\/\/www\.youtube\.com\/watch\?v=[-_a-zA-Z0-9]+$)/,

        vimeo: /^https?:\/\/vimeo\.com\/[-_a-zA-Z0-9]+$/,

        naverTv: /^https?:\/\/tv\.naver\.com\/v\/[-_a-zA-Z0-9]+$/,

        baseRegex: /(^https?:\/\/youtu\.be\/|^https?:\/\/www\.youtube\.com\/watch\?v=|^https?:\/\/vimeo\.com\/|^https?:\/\/tv\.naver\.com\/v\/)/,

        youtubeEmbedBase: 'https://www.youtube.com/embed/',

        vimeoEmbedBase: 'https://player.vimeo.com/video/',
      };
    },

    computed: {
      trimmedVideoLink() {
        return this.videoLink.trim();
      },
    },

    methods: {
      ...mapActions([
        'fetchVideoEmbedSrc',
      ]),

      getVideoId(link) {
        return link.replace(this.baseRegex, '');
      },

      getEmbed(link) {
        const embed = {
          src: '',
          is_iframe: false,
        };

        if (this.youtube.test(link)) {
          embed.src = `${this.youtubeEmbedBase}${this.getVideoId(link)}`;
          embed.is_iframe = true;
          return Promise.resolve(embed);
        }

        if (this.vimeo.test(link)) {
          embed.src = `${this.vimeoEmbedBase}${this.getVideoId(link)}`;
          embed.is_iframe = true;
          return Promise.resolve(embed);
        }

        if (this.naverTv.test(link)) {
          return this.fetchVideoEmbedSrc({ video_url: link })
            .then((result) => {
              embed.src = result.embed_src;
              embed.is_iframe = true;
              return embed;
            })
            .catch(() => (
              Promise.reject('video-load-failed-alert')
            ));
        }

        // unsupported video service
        embed.src = link;
        embed.is_iframe = false;
        return Promise.resolve(embed);
      },

      addVideo() {
        this.getEmbed(this.trimmedVideoLink)
          .then((embed) => {
            this.$emit('add', embed);
            this.clear();
          })
          .catch((err) => {
            if (isString(err)) {
              this.$root.$emit('show::modal', err);
            }
          });
      },

      clear() {
        this.videoLink = '';
      },
    },
  };
</script>

<style lang="scss">
  .add-video-modal {
    .add-video-input-area {
      margin-bottom: 16px;

      input {
        font-size: 14px;
        line-height: 1.29;
        font-weight: 400;
        padding: 15px 20px;
        color: rgba(0, 0, 0, 0.87);
        border: solid 1px #cccccc;
        border-radius: 4px;
        width: 100%;
        outline: none;

        &::placeholder {
          color: rgba(0, 0, 0, 0.26);
        }

        &:hover {
          border: solid 1px #b3b3b3;
        }

        &:focus,
        &:active {
          border: solid 1px #999999;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/app/my-cards/components/AddVideoModal.vue